import { Color, colors, getFontStyle, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

export interface StyledPillProps extends PropsWithChildren {
  backgroundColor?: Color;
  truncate?: boolean;
  size?: number;
}

export const Pill = styled.div<StyledPillProps>`
  ${getFontStyle('s', 'extraBold')};
  padding: ${getSpacing('xs')} ${getSpacing('xs')};
  border-radius: 16px;
  height: ${(props) => (props.size ? `${props.size}px` : '32px')};
  width: ${(props) => (props.size ? `${props.size}px` : 'fit-content')};
  background-color: ${(props) => props.backgroundColor || colors.black};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: ${(props) => (props.truncate ? '100px' : 'none')};
  & > p {
    line-height: 1;
  }
`;
